import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class NotificationService {
    getAuthToken() {
        const token = localStorage.getItem('adminToken');
        return token ? `Bearer ${token}` : '';
    }

    /**
     * Send notification
     */
    async sendNotification(data) {
        try {
            const response = await axios.post(`${API_URL}/notifications/send`, data, {
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get notification templates
     */
    async getTemplates() {
        try {
            const response = await axios.get(`${API_URL}/notifications/templates`, {
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Create notification template
     */
    async createTemplate(data) {
        try {
            const response = await axios.post(`${API_URL}/notifications/templates`, data, {
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get notification logs
     */
    async getLogs(page = 1, limit = 20, type = null, status = null) {
        try {
            const params = { page, limit };
            if (type) params.type = type;
            if (status) params.status = status;

            const response = await axios.get(`${API_URL}/notifications/logs`, {
                params,
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get notification statistics
     */
    async getStats() {
        try {
            const response = await axios.get(`${API_URL}/notifications/stats`, {
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get all buyers for targeting
     */
    async getBuyers() {
        try {
            const response = await axios.get(`${API_URL}/admin/users`, {
                headers: {
                    Authorization: this.getAuthToken()
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    handleError(error) {
        if (error.response) {
            throw {
                message: error.response.data.message || 'An error occurred',
                errors: error.response.data.errors || []
            };
        }
        throw {
            message: 'Network error. Please check your connection.',
            errors: []
        };
    }
}

export default new NotificationService();
